<template>
  <nav class="nav-bar">
    <div class="nav-container">
      <div class="brand">
        <router-link to="/feed" class="home-link">
          <span class="brand-span">
            <img src="../assets/largelogo.svg" alt="" />
          </span>
        </router-link>
      </div>
      <ul class="menu">
        <sidebar-menu-item type="home" label="Feed" link="/feed" name="Feed" />
        <sidebar-menu-item
          type="search"
          label="Discover"
          link="/search"
          name="Search"
        />
        <sidebar-menu-item
          type="likes"
          label="My Wishlist"
          link="/likes"
          name="Likes"
        />
      </ul>
      <hr class="sidebar-separator" />
      <div class="shops-container-wrapper">
        <ul class="shops-container">
          <sidebar-shop-item
            :shop="shop"
            v-for="shop in followedShops"
            :key="shop.id"
          />
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
import ShopService from "@/services/ShopService";
import SidebarMenuItem from "./SidebarMenuItem.vue";
import SidebarShopItem from "./SidebarShopItem.vue";
import { mapGetters } from "vuex";
export default {
  components: { SidebarShopItem, SidebarMenuItem },
  name: "Sidebar",
  data() {
    return {
      shops: [],
    };
  },
  computed: {
    ...mapGetters({
      followedShops: "shop/getFollowedShops",
    }),
  },
};
</script>

<style lang="scss" scoped>
.nav-bar {
  grid-area: nav-bar;
  // background-color: #272626;
  background-color: #141233;
  width: $nav_width;
  z-index: 3;
  flex-direction: column;
  min-height: 0;
  display: flex;
  position: relative;
  .nav-container {
    display: flex;
    width: $nav_width;
    flex-direction: column;
    flex: 1;
    min-height: 0;
    .brand {
      justify-content: space-between;
      flex-shrink: 0;
      flex-direction: row;
      display: flex;
      .home-link {
        border: 0;
        margin-bottom: 5px;
        flex: 1;
        text-decoration: none;
        &:hover {
          text-decoration: none;
        }
        img {
          margin-left: 6px;
        }
      }
    }
    .menu {
      margin-bottom: 0;
    }
    .sidebar-separator {
      background-color: #b3b3b3;
      border: none;
      height: 1px;
      margin: 12px 24px 12px 24px;
      min-height: 1px;
    }
    .shops-container-wrapper {
      overflow-y: scroll;
      height: 100%;
      &::-webkit-scrollbar {
        width: 8px;
      }
      &::-webkit-scrollbar-track {
        border-radius: 8px;
        background-color: transparent;
      }
      &::-webkit-scrollbar-thumb {
        border-radius: 5px;
        background-color: #515769;
      }
      .shops-container {
        margin-bottom: 0;
      }
    }
  }
}
</style>
